export default __webpack_public_path__ + "static/media/litho-landing-page-img-01.1ff0ca95.png";